var helperCreatePickOmit = require('./helperCreatePickOmit')

/**
 * 根据 key 过滤指定的属性值，返回一个新的对象
 *
 * @param {Object} obj 对象
 * @param {String/Array} key 键数组
 * @return {Object}
 */
var pick = helperCreatePickOmit(1, 0)

module.exports = pick



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/pick.js
// module id = 544
// module chunks = 98